import './App.css';
import { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
const Home = lazy(() => import('./pages/Home'));
const Sign = lazy(() => import('./pages/Sign'));

function App() {
  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL || '';

    const sendErrorLog = async (payload) => {
      try {
        await fetch(`${apiUrl}/api/monitor/error`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      } catch (e) {
        console.error('Impossible d’envoyer l’erreur de monitoring au backend', e);
      }
    };

    const onError = (message, source, lineno, colno, error) => {
      sendErrorLog({
        type: 'window.onerror',
        message: message?.toString?.() || 'Unknown message',
        url: source || window.location.href,
        lineNumber: lineno,
        columnNumber: colno,
        stack: error?.stack || '',
        userAgent: navigator.userAgent,
        pageUrl: window.location.href,
      });
      return false;
    };

    const onUnhandledRejection = (event) => {
      const reason = event.reason || {};
      sendErrorLog({
        type: 'unhandledrejection',
        message: reason.message || JSON.stringify(reason),
        stack: reason.stack || '',
        userAgent: navigator.userAgent,
        pageUrl: window.location.href,
      });
    };

    window.addEventListener('error', (event) => {
      onError(event.message, event.filename, event.lineno, event.colno, event.error);
    });
    window.addEventListener('unhandledrejection', onUnhandledRejection);

    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
    };
  }, []);

  return (
    <div className="App">
      <Router>
        <Suspense fallback={<div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>Chargement...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/AdminSign" element={<Sign />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;


